<!--  -->
<template>
  <div>
    <div class="banner">
        <div class="banner-text">
          <p class="title">{{$t('safety169')}}</p>
        </div>
      </div>
    <div class="make-a-report">
      <div class="row-line">
        <h2 class="title title1">{{$t('safety170')}}</h2>
        <p class="content">{{$t('safety171')}} </p>
      </div>
      <div class="row-line">
        <h2 class="title title1">{{$t('safety174')}}</h2>
        <h2 class="title">{{$t('safety175')}}</h2>
        <ul>
          <li>{{$t('safety176')}}</li>
          <li>{{$t('safety177')}}</li>
        </ul>
      </div>
      <div class="row-line">
        <h3>{{$t('safety178')}}</h3>
        <h2 class="title">{{$t('safety179')}}</h2>
        <ul>
          <li>{{$t('safety180')}}</li>
          <li>{{$t('safety181')}}</li>
          <li>{{$t('safety182')}}</li>
        </ul>
      </div>
      <div class="row-line">
        <h2 class="title">{{$t('safety183')}}</h2>
        <ul>
          <li>{{$t('safety184')}}</li>
          <li>{{$t('safety185')}}</li>
          <li>{{$t('safety186')}}</li>
          <li>{{$t('safety187')}}</li>
        </ul>
      </div>
      <div class="row-line">
        <h2 class="title">{{$t('safety188')}}</h2>
        <ul>
          <li>{{$t('safety189')}}</li>
          <li>{{$t('safety190')}}</li>
          <li>{{$t('safety191')}}</li>
        </ul>
      </div>
      <div class="row-line">
        <h2 class="title">{{$t('safety192')}}</h2>
        <ul>
          <li>{{$t('safety193')}}</li>
          <li>{{$t('safety194')}}</li>
        </ul>
      </div>
      <div class="row-line">
        <h2 class="title">{{$t('safety195')}}</h2>
        <ul>
          <li>{{$t('safety196')}}</li>
        </ul>
      </div>
      <div class="row-line">
        <h2 class="title">{{$t('safety197')}}</h2>
      </div>
      <div class="row-line">
        <h2 class="title">{{$t('safety198')}}</h2>
        <ul>
          <li>{{$t('safety199')}}</li>
          <li>{{$t('safety200')}}</li>
        </ul>
      </div>
      <div class="row-line">
        <h2 class="title">{{$t('safety201')}}</h2>
        <p class="content">{{$t('safety202')}}</p>
        <ul>
          <li>{{$t('safety203')}}</li>
          <li>{{$t('safety204')}}</li>
        </ul>
      </div>
      <div class="row-line">
        <h2 class="title">{{$t('safety205')}}</h2>
        <p class="content">{{$t('safety206')}}</p>
      </div>
  </div>
</div>
  </template>

<script>
export default {
  name: 'make-a-report',
  data () {
    return {}
  },

  components: {},

  computed: {},

  methods: {}
}
</script>
  <style lang='scss' scoped>
@import "@/assets/style/vars.scss";
@media (min-width: 750px) {
  .banner-content {
    padding: 50px;
    font-size: 18px;
    text-align: left;
  }
  .banner {
    width: 100%;
    height: 500px;
    background: url("../assets/images/banner-9.jpg") 50% 50% no-repeat;
    background-size: 100% auto;
    .title {
      color: #ffffff;
      font-size: 45px;
      font-weight: bold;
      text-align: center;
      line-height: 400px;
      margin-bottom: 40px;
    }
  }
  .make-a-report {
    width: 1000px;
    margin: 70px auto;
    padding-bottom: 40px;
    .row-line {
      margin-bottom: 40px;
      text-align: left;
      .title {
        font-size: 28px;
        font-weight: bold;
        color: #333;
        margin-bottom: 25px;
      }
      .title1 {
        font-size: 40px;
        font-weight: bold;
        color: #333;
        margin-bottom: 25px;
      }
      ul {
        list-style-type: disc;
        font-size: 24px;
        padding-left: 40px;
        color: #5e5e5e;
      }
      h3 {
        font-size: 24px;
        color: #000;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .content {
        font-size: 24px;
        color: #5e5e5e;
        margin-bottom: 20px;
        line-height: 28px;
        strong {
          font-size: 26px;
          color: #000;
          font-weight: bold;
        }
      }
      .row-line-button {
        text-align: right;
        margin-top: 20px;
        & > a {
          display: inline-block;
          width: 282px;
          height: 60px;
          background-color: $primary;
          color: #fff;
          text-align: center;
          line-height: 60px;
          font-size: 24px;
          border-radius: 8px;
          text-decoration: none;
        }
      }
    }
    .red {
      color: #f94a27;
    }
  }
}
@media (max-width: 750px) {
  ul,h3{
  font-size: 14px;
  color: #5e5e5e;
}
ul {
  list-style-type: disc;
  margin-left: 20px;
}
h3 {
  margin-bottom: 10px;
}
  .banner-content {
    padding: 10px;
    font-size: 14px;
    text-align: left;
  }
  .banner {
    width: 100%;
    height: 150px;
    background: url("../assets/images/banner-9.jpg") no-repeat;
    background-size: 100% 100%;
    .banner-text {
      padding: 25px;
      p {
        margin-bottom: 10px;
        font-size: 14px;
        line-height: 18px;
        color: #5e5e5e;
      }
      .title {
        color: #ffffff;
        font-size: 25px;
        font-weight: bold;
        text-align: center;
        line-height: 100px;
        margin-bottom: 20px;
      }
    }
  }
  .make-a-report {
    padding: 35px 25px;
    padding-bottom: 40px;
    .row-line {
      margin-bottom: 30px;
      text-align: left;
      .title {
        font-size: 20px;
        font-weight: bold;
        color: #333;
        margin-bottom: 15px;
      }
      .title1 {
        font-size: 28px;
      }
      img {
        width: 75px;
        height: 150px;
      }
      .content {
        font-size: 14px;
        color: #5e5e5e;
        margin-bottom: 10px;
        line-height: 18px;
      }
      .row-line-button {
        text-align: right;
        margin-top: 20px;
        & > a {
          display: inline-block;
          width: 100%;
          height: 35;
          background-color: $primary;
          color: #fff;
          text-align: center;
          line-height: 35px;
          font-size: 18px;
          border-radius: 5px;
          text-decoration: none;
        }
      }
    }
    .red {
      color: #f94a27;
    }
  }
}
</style>
